export enum Height {
  empty = 0,
  full = 'auto',
}
